import { InitOptions } from 'i18next';
import { formatter } from '../formatters/interpolationFormatter';

export const baseOptions: InitOptions = {
  fallbackLng: 'en-US',
  ns: [],
  keySeparator: false,
  nsSeparator: false,
  interpolation: {
    alwaysFormat: true,
    escapeValue: false,
    formatSeparator: ',',
    format: formatter,
    skipOnVariables: true,
  },
  react: {
    transSupportBasicHtmlNodes: false,
    transKeepBasicHtmlNodesFor: [],
  },
};
